import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'search-graph-deal.deal-label',
		defaultMessage: 'Deal',
		description: 'Deal subtype label',
	},
	closedOn: {
		id: 'search-graph-deal.closed-on',
		defaultMessage: 'Closed on {date}',
		description: 'Date when the deal was closed',
	},
});
